import { useEffect, useState } from "react";

export default function PhoneInput({ phonecode,phonenumber, onChange,label, numbererror,codeerror,required}) {

  const handleCodeChange = (e) => {
    onChange(e.target.value, phonenumber);
  };

  const handleNumberChange = (e) => {
    onChange(phonecode, e.target.value);
  };

  const errorMsg = numbererror||codeerror

  return (
    <div className="UI-form-group">
      <label className={`UI-label ${errorMsg && "!tw-border-[#ff0000]"}`}>{label || "Phone Number"}{required && <sup>*</sup>}</label>
      <div className="tw-flex">
      <input
        type="text"
        value={phonecode}
        onChange={handleCodeChange}
        className={`UI-input col-md-3 !tw-rounded-r-none !tw-border-r-0 focus:!tw-border-r focus:!tw-border-[#3574de] ${codeerror && "!tw-border-[#ff0000]"} !tw-border-r`}
        placeholder="+1"
      />
      <input
        type="text"
        value={phonenumber}
        onChange={handleNumberChange}
        className={`UI-input col-md-9 !tw-rounded-l-none !tw-border-l-0 focus:!tw-border-l focus:!tw-border-[#3574de] ${numbererror && "!tw-border-[#ff0000] !tw-border-l"}`}
        placeholder="9999999999"
      />
      </div>
      {errorMsg && <div>
        <p className="tw-text-[10px] tw-text-[#ff0000] m-0 tw-pt-0.5 tw-pl-1">{errorMsg}</p>
      </div>}
    </div>
  );
}
